export default __webpack_public_path__ + "static/media/1665.42ba29ca.png";